import axios from 'axios';
import useAuth from './useAuth';

export default function useRefreshToken() {
	const { auth, setAuth } = useAuth();

	const refresh = async () => {
		try {
			const response = await axios.post(
				'/web/user/refreshToken',
				{},
				{
					headers: { 'Content-Type': 'application/json' },
					withCredentials: true,
				}
			);

			setAuth({
				accessToken: response.headers.accesstoken,
				isTriedGetAccessToken: true,
				...response.data,
			});

			return response.data;
		} catch (error) {
			console.error('Error refreshing token:', error);

			// 轉為登出狀態
			setAuth({
				accessToken: null,
				isTriedGetAccessToken: true,
			});

			if (error.response) {
				// 這裡 error.response 是包含 HTTP 響應的錯誤物件
				const { status } = error.response;
				console.error('HTTP error status:', status);
				// 你可以根據狀態碼來處理錯誤，例如 400 代表請求錯誤
				if (status === 400) {
					// 這裡可以進行一些處理，比如顯示錯誤信息或重新登入
					return error.response;
				}
			} else if (error.request) {
				// 如果沒有收到回應（網絡錯誤等）
				console.error('No response received from the server');
			} else {
				// 其他錯誤
				console.error('Error', error.message);
			}
			// throw error;
		}
	};

	return refresh;
}
